<h2 class="h6">Lekkerland Konto löschen</h2>

<p>Geben Sie hier Ihre E-Mail-Adresse des Lekkerland Kontos an, das Sie löschen möchten. Bitte beachten Sie, dass Sie damit den Zugang zur Lekkerland App, dem Lekkerland24 Shop, dem Kundenportal und weiteren digitalen Angeboten der Lekkerland SE verlieren.</p>

@if (alertMessage()) {
  <ui-alert [alert]="alertMessage()"></ui-alert>
}

<form #form="ngForm" (ngSubmit)="onSubmit()">
  <ui-form-text [data]="itemEmail" [formControl]="emailControl"></ui-form-text>
  @if (hasPending()) {
    <ui-alert
      message="Vielen Dank, Ihr Antrag auf Kontolöschung ist eingegangen und wird schnellstmöglich bearbeitet."
      theme="info"
    ></ui-alert>
  }
  <ui-form-submit [data]="itemSubmit"></ui-form-submit>
</form>
